import React from 'react';
import { Mail } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import Footer from './Footer';

const ContactSection = () => {
  const { isDark } = useTheme();
  
  return (
    <section id="contact" className="contact-section">
      {/* Section Title */}
      <h2 className="section-title">
        SEEK <span className="section-title-faded">COUNSEL</span>
      </h2>
      <p className="section-subtitle">You've come this far, so you'll probably need it.</p>

      {/* Email */}
      <div className="email-container">
        <div className="email-display">
          <Mail size={24} />
          <span>alan.shteynberg@gmail.com</span>
        </div>
      </div>

      <p className="section-paragraph">If you know where to look, you'll usually find me at a triangulation point nestled somewhere in the heart of Durotar; east of The Crossroads in The Barrens, South of Ragefire Chasm in Orgrimmar, and always missing the Zeppelin at the Landing.</p>

      {/* Image */}
      <div className="contact-image-container">
        <img 
          src="https://customer-assets.emergentagent.com/job_alans-resume/artifacts/ydtlpb99_the-battery-philadelphia-orgrimmar-zeppelin-landing.png" 
          alt="The Battery Philadelphia - Orgrimmar Zeppelin Landing" 
          className="contact-image"
        />
        <p className="image-attribution">Source: <a href="https://www.phillymag.com/property/2023/10/05/the-battery-apartment-profile/" target="_blank" rel="noopener noreferrer">The Battery in Philadelphia, PA</a></p>
      </div>

      <blockquote className="section-quote">
        <p>"Life is so terrible, it would have been better not to have been born. Who is so lucky? Not one in a hundred thousand!"</p>
        <cite>-Jewish saying</cite>
      </blockquote>

      <Footer />

      <style jsx>{`
        .contact-section {
          padding-bottom: 20px;
        }

        .section-title {
          font-family: 'Poppins', sans-serif;
          font-size: clamp(36px, 6vw, 56px);
          font-weight: 700;
          color: ${isDark ? '#fff' : '#151312'};
          line-height: 1;
          letter-spacing: -0.02em;
          margin: 0 0 32px 0;
          transition: color 0.3s ease;
        }

        .section-title-faded {
          color: ${isDark ? 'rgba(182, 180, 189, 0.2)' : 'rgba(21, 19, 18, 0.15)'};
        }

        .section-subtitle {
          font-family: 'Poppins', sans-serif;
          font-size: 18px;
          font-weight: 400;
          font-style: italic;
          color: ${isDark ? '#998f8f' : '#64748b'};
          margin: -20px 0 20px 0;
          transition: color 0.3s ease;
        }

        .section-paragraph {
          font-family: 'Poppins', sans-serif;
          font-size: 16px;
          font-weight: 400;
          color: ${isDark ? '#998f8f' : '#64748b'};
          line-height: 1.6;
          margin: 0 0 24px 0;
          max-width: 600px;
          transition: color 0.3s ease;
        }

        .section-numbers {
          font-family: 'Poppins', sans-serif;
          font-size: 18px;
          font-weight: 500;
          color: #f46c38;
          line-height: 1.4;
          margin: 0 0 32px 0;
          letter-spacing: 0.1em;
        }

        .section-quote {
          font-family: 'Poppins', sans-serif;
          font-size: 15px;
          font-style: italic;
          color: ${isDark ? '#998f8f' : '#64748b'};
          line-height: 1.6;
          margin: 0 0 32px 0;
          max-width: 600px;
          padding-left: 20px;
          border-left: 2px solid rgba(244, 108, 56, 0.5);
          transition: color 0.3s ease;
        }

        .section-quote p {
          margin: 0 0 8px 0;
        }

        .section-quote cite {
          font-size: 14px;
          color: #f46c38;
        }

        .email-container {
          margin-bottom: 40px;
        }

        .email-display {
          display: inline-flex;
          align-items: center;
          gap: 12px;
          font-family: 'Poppins', sans-serif;
          font-size: 20px;
          font-weight: 500;
          color: #f46c38;
        }

        .contact-image-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin: 32px 0;
        }

        .contact-image {
          max-width: 100%;
          height: auto;
          border-radius: 12px;
        }

        .image-attribution {
          font-family: 'Poppins', sans-serif;
          font-size: 12px;
          color: #6a6b6e;
          margin: 8px 0 0 0;
          word-break: break-all;
          max-width: 100%;
        }

        .image-attribution a {
          color: #6a6b6e;
          text-decoration: none;
          transition: opacity 0.2s ease;
          word-break: break-all;
        }

        .image-attribution a:hover {
          opacity: 0.8;
        }

        @media (max-width: 600px) {
          .section-title {
            font-size: 32px;
            margin-bottom: 24px;
          }

          .section-subtitle {
            font-size: 16px;
            margin: -16px 0 16px 0;
          }

          .section-paragraph {
            font-size: 14px;
            margin-bottom: 24px;
          }

          .section-quote {
            font-size: 14px;
            padding-left: 16px;
            margin-bottom: 24px;
          }

          .section-quote cite {
            font-size: 13px;
          }

          .email-display {
            font-size: 16px;
            gap: 10px;
          }

          .footer {
            margin-top: 40px;
          }
        }
      `}</style>
    </section>
  );
};

export default ContactSection;
